import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Multiselect from "multiselect-react-dropdown";
import React from "react";
import Select from "react-select";

import {
  DICOM_MODALITIES,
  OPERATIONS_DROPDOWN,
} from "../../../DropdownConstants";

const ConfigPartTwo = (props) => {
  const {
    handleClick,
    styles,
    step,
    isFormValid,
    setOperation,
    operation,
    setFetchType,
    setCFindChecked,
    fetchType,
    cFindChecked,
    modalityMultiselect,
    onSelect,
    errors,
    onRemove,
  } = props;

  const handleFetchTypeChange = (event) => {
    setFetchType(event.target.value);
  };

  const handleCFindChange = (event) => {
    setCFindChecked(event.target.checked);
  };

  const CFIND_DROPDOWN = [{}];

  // Check if operation is selected
  const isOperationSelected = !!operation;

  // Check if modality is selected when C-FIND is checked
  const isModalitySelected = cFindChecked && modalityMultiselect.length > 0;

  return (
    <div>
      <div className="hl7-modal-inputs">
        <div>
          <div>
            <label className="label-fields font-weight-bold">
              Operation{" "}
              <sup style={{ color: "red", fontWeight: "bold" }}>*</sup>
            </label>
          </div>
          <Select
            placeholder="Select Operation"
            name="operation"
            options={OPERATIONS_DROPDOWN}
            onChange={setOperation}
            value={operation}
            isClearable={true}
            theme={(theme) => ({
              ...theme,
              borderRadius: "5px",
              colors: styles.colors,
            })}
            styles={{
              control: (provided) => ({
                ...provided,
                ...styles.controlStyles,
              }),

              option: (provided, state) => ({
                ...provided,
                backgroundColor: "black",
                color: "white",
              }),

              singleValue: (provided) => ({
                ...provided,
                fontWeight: "normal",
              }),
              placeholder: (provided) => ({
                ...provided,
                fontWeight: "normal",
              }),
            }}
          />
          {errors.operation && (
            <span className="errorStyles">{errors?.operation}</span>
          )}
        </div>
        {operation?.value === "qr" && (
          <div className="d-flex flex-column">
            <div className="fetch-type">
              <FormControl>
                <FormLabel
                  className="label-fields"
                  id="demo-row-radio-buttons-group-label"
                >
                  Fetch Type
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={fetchType}
                  onChange={handleFetchTypeChange}
                >
                  <FormControlLabel
                    value="CGET"
                    control={<Radio />}
                    label="C-GET"
                  />
                  <FormControlLabel
                    value="CMOVE"
                    control={<Radio />}
                    label="C-MOVE"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="c-find">
              <div className="d-flex justify-content-start align-items-center" style={{marginLeft:'-12px'}}>
                <div>
                  <Checkbox
                    checked={cFindChecked}
                    onChange={handleCFindChange}
                  />
                </div>
                <div>C-FIND</div>
              </div>
            </div>
            <div className="c-find-options">
              <div className="d-flex justify-content-between flex-column align-items-start">
                {cFindChecked && (
                  <>
                    <div className="label-fields">Modality</div>
                    <Multiselect
                      options={DICOM_MODALITIES}
                      className="mt-1"
                      displayValue="label"
                      style={{
                        chips: { background: "black", fontWeight: "normal" },
                        multiselectContainer: {
                          background: "#121C1B",
                          border: "1px solid #0f9077",
                          borderRadius: "5px",
                          outline: "none",
                          width: "32rem",
                        },
                        searchBox: {
                          border: "none",
                        },
                        option: {
                          background: "black",
                          color: "#FFFFFF",
                          fontWeight: "normal",
                        },
                      }}
                      onSelect={onSelect}
                      onRemove={onRemove}
                      selectedValues={modalityMultiselect}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-around">
          {step === 2 ? (
            <div className="d-flex justify-content-around">
              <div className="prev">
                <button
                  className="btn-class mt-3 "
                  type="submit"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  onClick={() => handleClick("prev")}
                >
                  PREV
                </button>
              </div>
              <div className="submit-config">
                <button
                  className="btn-class mt-3"
                  type="submit"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  onClick={() => handleClick("submit")}
                  disabled={
                    !isFormValid ||
                    !isOperationSelected ||
                    !(cFindChecked ? isModalitySelected : true)
                  }
                >
                  SUBMIT
                </button>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-between">
              {step !== 0 && (
                <div className="">
                  <button
                    className="btn-class mt-3 "
                    type="submit"
                    name="btn-click"
                    style={{ marginLeft: "1rem", marginRight: "1rem" }}
                    onClick={() => handleClick("prev")}
                  >
                    PREV
                  </button>
                </div>
              )}
              <div>
                <button
                  className="btn-class mt-3"
                  type="submit"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  onClick={() => handleClick("next")}
                  disabled={
                    !isOperationSelected ||
                    !(cFindChecked ? isModalitySelected : true)
                  }
                >
                  NEXT
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigPartTwo;
